// Block-level elements whose text would otherwise run into the next block's
// when markup is flattened to plain text.
export const HTML_BLOCK_ELEMENTS_SELECTOR = 'p, div, li, br, h1, h2, h3, h4, h5, h6, blockquote';
